import { ISearchQuickResults } from "../types/ISearch";

const NavInitialState = {
  quickSearchResults: [] as ISearchQuickResults[],
  quickSearchingFlag: false,
  quickSearchInput: "",
  contextMenuOpen: "",
};
export default NavInitialState;
